module.exports = __webpack_public_path__ + "static/screen-classic-mac-laptop@2x-ab4e5cc91bf21a61aab708b06241cfe9.webp";